/* eslint-disable no-fallthrough */
import { GregorioGlyph } from '../structures/GregorioGlyph';
import { GregorioGlyphType } from '../enums/GregorioGlyphType';
import { GregorioLiquescentia } from '../enums/GregorioLiquescentia';
import { GregorioSign } from '../enums/GregorioSign';
import { GregorioElement, GregorioMiscElementInfo } from '../structures/GregorioSyllable';
import { GregorioType } from '../enums/GregorioType';
import { close_element, cut_before, glyph_note_ambitus, is_fused, is_tail_liquescentia } from './other';
import { GregorioSpace } from '../enums/GregorioSpace';


export function gabc_det_elements_from_glyphs(glyphs: GregorioGlyph[]): GregorioElement[] {
  /* the last element we have successfully added to the list of elements */
  // gregorio_element * current_element = NULL;
  /* the first element, that we will return at the end. We have to consider
   * it because the gregorio_element struct does not have previous_element
   * element. */
  // let first_element: GregorioElement = null;
  /* the first_glyph of the element that we are currently determining */
  // gregorio_glyph * first_glyph = current_glyph;
  /* the last real (GRE_GLYPH) that we have processed */
  /* boolean necessary to determine some cases */
  let do_not_cut = false;
  let force_cut = false;

  // gregorio_not_null(current_glyph, gabc_det_elements_from_glyphs, return NULL);
  /* first we go to the first glyph in the chained list of glyphs (maybe to
   * suppress ?) */
  // gregorio_go_to_first_glyph(& current_glyph);

  const elements: GregorioElement[] = [];

  // const first_glyph = glyphs[0];
  let first_glyph_i = 0;

  for (let i = 0; i < glyphs.length; i++) {
    const current_glyph: GregorioGlyph = glyphs[i];
    const next_glyph: GregorioGlyph | null = i + 1 < glyphs.length ? glyphs[i + 1] : null;
    let previous_glyph = i > 0 ? glyphs[i - 1] : null;

    if (current_glyph.type !== GregorioType.GLYPH) {
      force_cut = false;
      /* we must not cut after a glyph-level space */
      if (current_glyph.type == GregorioType.SPACE || current_glyph.type === GregorioType.END_OF_LINE) {
        first_glyph_i = cut_before(glyphs, elements, i, first_glyph_i);
        gregorio_add_misc_element(elements, current_glyph.type, current_glyph.misc);
        first_glyph_i++;

        // switch (current_glyph.misc.info.space) {
        //   case GregorioSpace.ZERO_WIDTH:
        //   case GregorioSpace.HALF_SPACE:
        //   case GregorioSpace.INTERGLYPH_SPACE:
        //     if (!next_glyph) {
        //       first_glyph_i = close_element(glyphs, elements, i, first_glyph_i);
        //     }
        //     // current_glyph = current_glyph -> next;
        //     do_not_cut = true;
        //     continue;
        //   default:
        //     /* any other space should be handled normally */
        //     break;
        // }
        continue;
      } 

      first_glyph_i = cut_before(glyphs, elements, i, first_glyph_i);
      
      if (current_glyph.type == GregorioType.CLEF) {
        gregorio_add_misc_element(elements, current_glyph.type, current_glyph.misc);
        first_glyph_i++;
      } else if (current_glyph?.misc?.info?.space !== GregorioSpace.NEUMATIC_CUT ||
        (next_glyph && next_glyph.type === GregorioType.SPACE)) {
        gregorio_add_misc_element(elements, current_glyph.type, current_glyph.misc);
      }
      
      continue;
    }

    if (is_fused(current_glyph.notes.liquescentia)) {
      do_not_cut = true;
    } else if (force_cut) {
      first_glyph_i = cut_before(glyphs, elements, i, first_glyph_i);
      previous_glyph = null;
    }
    force_cut = false;

    switch (current_glyph.notes.glyph_type) {
      case GregorioGlyphType._2_PUNCTA_INCLINATA_ASCENDENS:
      case GregorioGlyphType._3_PUNCTA_INCLINATA_ASCENDENS:
      case GregorioGlyphType._4_PUNCTA_INCLINATA_ASCENDENS:
      case GregorioGlyphType._5_PUNCTA_INCLINATA_ASCENDENS:
      case GregorioGlyphType.PUNCTUM_INCLINATUM:
      case GregorioGlyphType.ALTERATION:
        if (!do_not_cut) {
          first_glyph_i = cut_before(glyphs, elements, i, first_glyph_i);
          do_not_cut = true;
        }
        break;

      case GregorioGlyphType.STROPHA_AUCTA:
      case GregorioGlyphType.STROPHA:
        if (
          current_glyph.notes.liquescentia &
          (GregorioLiquescentia.AUCTUS_ASCENDENS | GregorioLiquescentia.AUCTUS_DESCENDENS)
        ) {
          force_cut = true;
        }
      /* fall through */
      case GregorioGlyphType._2_PUNCTA_INCLINATA_DESCENDENS:
      case GregorioGlyphType._3_PUNCTA_INCLINATA_DESCENDENS:
      case GregorioGlyphType._4_PUNCTA_INCLINATA_DESCENDENS:
      case GregorioGlyphType._5_PUNCTA_INCLINATA_DESCENDENS:
        /* we don't cut before, so we don't do anything else */
        if (do_not_cut) {
          do_not_cut = false;
        }
        break;

      default:
        if (
          previous_glyph &&
          previous_glyph.type === GregorioType.GLYPH &&
          !is_tail_liquescentia(previous_glyph.notes.liquescentia)
        ) {
          let break_early = false;
          let ambitus: number;

          switch (previous_glyph.notes.glyph_type) {
            case GregorioGlyphType.PUNCTUM:
            case GregorioGlyphType.VIRGA:
            case GregorioGlyphType.BIVIRGA:
            case GregorioGlyphType.TRIVIRGA:
            case GregorioGlyphType.VIRGA_REVERSA:
            case GregorioGlyphType.STROPHA:
            case GregorioGlyphType.STROPHA_AUCTA:
            case GregorioGlyphType.DISTROPHA:
            case GregorioGlyphType.DISTROPHA_AUCTA:
            case GregorioGlyphType.TRISTROPHA:
            case GregorioGlyphType.TRISTROPHA_AUCTA:
              /* we determine the last pitch */
              ambitus = glyph_note_ambitus(current_glyph, previous_glyph);
              if (ambitus === 0) {
                do_not_cut = false;
                break_early = true;
              }
              break;

            case GregorioGlyphType._2_PUNCTA_INCLINATA_DESCENDENS:
            case GregorioGlyphType._3_PUNCTA_INCLINATA_DESCENDENS:
            case GregorioGlyphType._4_PUNCTA_INCLINATA_DESCENDENS:
            case GregorioGlyphType._5_PUNCTA_INCLINATA_DESCENDENS:
            case GregorioGlyphType.PUNCTUM_INCLINATUM:
              switch (current_glyph.notes.glyph_type) {
                case GregorioGlyphType.PUNCTUM:
                case GregorioGlyphType.VIRGA:
                case GregorioGlyphType.BIVIRGA:
                case GregorioGlyphType.TRIVIRGA:
                case GregorioGlyphType.VIRGA_REVERSA:
                // case GregorioGlyphType.STROPHA:
                // case GregorioGlyphType.STROPHA_AUCTA:
                case GregorioGlyphType.DISTROPHA:
                case GregorioGlyphType.DISTROPHA_AUCTA:
                case GregorioGlyphType.TRISTROPHA:
                case GregorioGlyphType.TRISTROPHA_AUCTA:
                  ambitus = glyph_note_ambitus(current_glyph, previous_glyph);
                  if (ambitus > -2 && ambitus < 2) {
                    do_not_cut = false;
                    break_early = true;
                  }
                  break;

                default:
                  /* do nothing in particular */
                  break;
              }
              break;

            default:
              /* do nothing in particular */
              break;
          }

          // if (break_early) {
          // first_glyph_i = close_element(glyphs, elements, i, first_glyph_i);
          // break;
          // }
        }

        if (do_not_cut) {
          do_not_cut = false;
        } else {
          first_glyph_i = cut_before(glyphs, elements, i, first_glyph_i);
        }
    }

    if (current_glyph.notes.notes.length > 0 && 
      current_glyph.notes.notes[current_glyph.notes.notes.length - 1].signs & (GregorioSign.PUNCTUM_MORA)) {
      force_cut = true;
    }

    if (!next_glyph) {
      first_glyph_i = close_element(glyphs, elements, i, first_glyph_i);
    }
  } /* end of while */


  return elements;
}

function gregorio_add_misc_element(elements: GregorioElement[],
  type: GregorioType, info: GregorioMiscElementInfo) {
  // gregorio_element *special = create_and_link_element(current_element);
  const special = new GregorioElement();

  special.type = type;
  special.misc = info;

  if (type == GregorioType.SPACE) {
    /* this was copied into the glyph, so we need to clear it to avoid a
     * double-free */
    info.info.ad_hoc_space_factor = undefined;
  }

  elements.push(special);
}
